import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  root: {
    fontWeight: 400,
    selectors: {
      '.ms-Label::after': {
        color: theme.palette.accentError,
      },
      '.ms-TextField-field': {
        fontWeight: 400,
        display: 'flex',
        alignItems: 'center',
        paddingRight: 34,
        height: '100%',
      },
      '.ms-TextField-fieldGroup': {
        backgroundColor: theme.palette.neutralWhite,
        borderColor: theme.palette.neutralTertiary,
        fontColor: theme.palette.neutralSecondary,
        fontWeight: 400,
        selectors: {
          'input::placeholder': {
            color: theme.palette.neutralSecondary,
            fontWeight: 400,
          },
          '&:focus': {
            borderColor: theme.palette.neutralDark,
          },
          '&:hover': {
            borderColor: theme.palette.themeDarkerAlt,
          },
        },
      },
    },
  },

  errorMessage: {
    color: theme.palette.accentError,
    fontSize: pxToRem(12),
    fontWeight: 400,
    marginTop: pxToRem(5),
  },
  flexRow: {
    display: 'flex',
    flexFlow: 'row',
  },
  calendar: {
    '.ms-DatePicker-wrap': {
      display: 'flex',
      justifyContent: 'flex-end',
    },
  },
});
